import styled from "styled-components";

export const ReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ReviewSubtitle = styled.div`
  color: ${(props) => props.theme.colors?.greyFour || "#6B7280"};
  font-size: 14px;
  line-height: 140%;
`;

export const UsersCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ReviewTabsContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ann-tabs__list {
    gap: 8px;
  }
`;

export const TabPanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 12px;
  width: 100%;
`;

export const TabPanelButton = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const StepperContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${(props) => props.theme?.colors?.white || "#fff"};
  padding-bottom: 8px;
`;

